// extracted by mini-css-extract-plugin
module.exports = {"loginSectionContainer":"loginSection_loginSectionContainer__VSM9o","label":"loginSection_label__6mfKu"};